import Link from 'next/link'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {
  IconMessage,
  IconCreditCard,
  Button,
  TextCaption2,
  IconEdit,
  TextBody,
  colors,
} from '@blocket/blocket-ui'
import ProfileCard from 'components/sharedComponents/ProfileCard/ProfileCard'
import { UserProfileSection } from 'components/sharedComponents/ProfileCard/styling'
import EditModal from './EditModal'

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap; /*small devices like iphone 5*/
  margin-top: 18px;
`

const EditButton = styled(Button)`
  margin: 0px 16px 8px 0px;
  svg {
    margin-right: 10px;
  }
`

const BadgeSection = styled.div`
  display: flex;
  flex-flow: wrap;
  align-items: center;
  margin-top: 8px;
`

const RowWrapper = styled.div`
  display: flex;
  padding: 2px 0px;
`

const SpaceDivider = styled.span`
  padding: 0px 8px;
  color: ${colors.grey800};
`

const BadgeText = styled(TextCaption2)`
  margin-left: 4px;
`
const Description = styled(TextBody)`
  text-overflow: ellipsis;
  overflow: hidden;
  margin-top: 14px;
`

const ProfileData = ({
  profileData: { account = {}, communication = {}, credits = {}, profileInfo = {} },
}) => {
  const [showEditModal, setShowEditModal] = useState(false)
  const blocketAccountId = useSelector((state) => state.account.user.propertyMap.accountId)

  const { name, description } = profileInfo
  const showReplyTimeBadge = Boolean(communication.replyTime?.text)
  const showCreditsBadge = credits.available > 0

  const showFirstSpace = showReplyTimeBadge && showCreditsBadge

  const editProfile = () => {
    setShowEditModal(true)
  }

  return (
    <UserProfileSection data-cy="user-profile-info">
      {showEditModal && (
        <EditModal
          close={() => setShowEditModal(false)}
          userName={name}
          currentDescription={description}
        />
      )}
      <ProfileCard profileName={name} account={account} maskForHotjar />
      <BadgeSection>
        {showReplyTimeBadge && (
          <RowWrapper>
            <IconMessage width={16} height={20} />
            <BadgeText>{communication.replyTime.text}</BadgeText>
          </RowWrapper>
        )}
        {showFirstSpace && <SpaceDivider> · </SpaceDivider>}
        {showCreditsBadge && (
          <RowWrapper>
            <IconCreditCard width={16} height={20} />
            <BadgeText>{credits.availableTxt}</BadgeText>
          </RowWrapper>
        )}
      </BadgeSection>
      {description && <Description>{description}</Description>}
      <ButtonWrapper>
        <EditButton type="primary" size="tiny" onClick={editProfile}>
          <IconEdit color={colors.white100} width={16} height={16} />
          Redigera profil
        </EditButton>
        <Button type="secondary" size="tiny">
          <Link href={`/profil/${blocketAccountId}`}>Visa publik profil</Link>
        </Button>
      </ButtonWrapper>
    </UserProfileSection>
  )
}

ProfileData.propTypes = {
  profileData: PropTypes.object.isRequired,
}

export default ProfileData
